/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Paste Event or Text" |
*
* @param {Paste_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_aria_label = /** @type {((inputs?: Paste_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller Evenement ou Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis oder Text einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla evento o testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить событие или текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar evento o texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴事件或文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントまたはテキストを貼り付け")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट या टेक्स्ट पेस्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar evento ou texto")
	return /** @type {LocalizedString} */ ("Paste Event or Text")
});